import { useCallback, useEffect, useRef, useSyncExternalStore } from "react";

import { getBusySnapshot, popBusy, pushBusy, subscribeBusy } from "utils/busyStore";

/** The active busy entry ({ message, note }) or null when nothing is in flight. */
export function useBusy() {
  return useSyncExternalStore(subscribeBusy, getBusySnapshot, getBusySnapshot);
}

/** True while any user-initiated request is in flight — use to disable submits. */
export function useIsBusy() {
  return useBusy() != null;
}

/**
 * Imperative `setBusy(message | null)` for spans the API layer cannot bracket on
 * its own — e.g. a payment window that stays open across several requests.
 * Clears itself on unmount so a navigation mid-span cannot strand the overlay.
 */
export function useBusySpan(defaultNote) {
  const token = useRef(null);
  const note = useRef(defaultNote);
  note.current = defaultNote;

  useEffect(() => () => popBusy(token.current), []);

  return useCallback((message) => {
    popBusy(token.current);
    token.current = message ? pushBusy(message, note.current) : null;
  }, []);
}

export default useBusy;
